import { NgModule } from "@angular/core";
import { CommonModule, CurrencyPipe } from "@angular/common";
import { RangeSliderComponent } from "./range-slider/range-slider.component";

@NgModule({
  imports: [CommonModule],
  declarations: [RangeSliderComponent],
  exports: [RangeSliderComponent],
  providers: [CurrencyPipe]
})
export class RangeSliderModule {}
